import React,{Component} from 'react';

class Footer extends Component{
   
    render() {
  
        return (<>
         <footer id="footer">
            <div className="container-fluid">
                <div className="row text-center">
                    <div className="col-md-12">
                        <div className="c-pannel no-margin">
                            <small>© Copyright 2020. All Right Reserved.</small>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        </>    
      );
    }
}




export default Footer;
